module.exports = __webpack_public_path__ + "img/store_video@2x.ca624b0.webp";